export const CLOUD = 'cloud';
export const LOCAL = 'local';

export const CLOUD_VARIABLES_META_TYPE = 'cloudVariables';

export const CURRENT_BLOCK_INDEX = 0;
export const GET_CODE_BLOCK = 3;
